export const removeSpacingFromString = (str: string) => {
  return str.replace(/\s/g, "");
};
